<template>
  <div>
    <div role="button" @click.prevent="handleToggle" style="width: fit-content">
      <FormulateInput
        type="switch"
        v-model="isToggled"
        :disabled="!canEditFields"
        valueLabelTrue="Biaya Tambahan"
        valueLabelFalse="Biaya Tambahan"
      />
    </div>

    <div v-if="isToggled">
      <AdditionalCostsTable
        :additionalCosts="additionalCosts"
        :isAddingRates="isAddingRates"
        :prefixUrl="prefixUrl"
        :canEditFields="canEditFields"
      />
    </div>

    <b-modal
      title="Abaikan biaya tambahan?"
      ref="mc-modal-cancel"
      size="md"
      centered
      scrollable
      hide-header-close
    >
      <div>
        <p>Apakah anda yakin ingin mengabaikan biaya tambahan?</p>
        <p>Data yang sudah tersimpan akan hilang.</p>
      </div>

      <template #modal-footer="{ cancel }">
        <div class="d-flex mx-0">
          <McButton @click="cancel()" variant="secondary" class="me-2" text="Tidak" />
          <McButton @click="handleDeleteAll" variant="primary" text="Ya" />
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import McButton from '@/components/McButton'

import AdditionalCostsTable from './AdditionalCostsTable'
import { EventBus } from '../lib/event-bus.js'

export default {
  components: {
    McButton,
    AdditionalCostsTable,
  },
  props: {
    additionalCosts: {
      type: Array,
      default: () => [],
    },
    isAddingRates: {
      type: Boolean,
      default: false,
    },
    prefixUrl: {},
    canEditFields: {},
  },
  data() {
    return {
      isToggled: true,
    }
  },
  mounted() {
    if (this.additionalCosts.length == 0) {
      this.isToggled = false
    }
  },
  methods: {
    handleToggle() {
      if (this.isToggled == false) {
        this.isToggled = true
        return
      }

      this.$refs['mc-modal-cancel'].show()
    },

    handleDeleteAll() {
      this.isToggled = false
      EventBus.$emit('additionalCost:deleteAll')
      this.$refs['mc-modal-cancel'].hide()
    },
  },
}
</script>
